import capitalize from '@/filters/capitalize';

export default (words = '') => words.split(' ').map(capitalize).join(' ');
